import {
  ACTIVITY_LOG_FORM_FEILDS,
  ACTIVITY_LOG_FORM_FEILDS_LABELS,
  ACTIVITY_LOG_STATUSES,
} from 'features/wells/overview/activityLog/helpers/activityLog.constants';
import { Field } from 'formik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
import withStyles from '@material-ui/styles/withStyles';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import DatePickerFormik from 'app/components/form/formik/DatePickerFormik';
import EditorFormik from 'app/components/form/formik/EditorFormik';

import { Grid } from '@material-ui/core';

import { Format } from 'app/app.constants';

const ActivityLogFormFields = ({ classes, responsibleUsers }) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Field
            fullWidth
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.ACTIVITY_NAME}
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.ACTIVITY_NAME}
            component={TextFieldFormik}
            className={classes.field}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.DESCRIPTION}
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.DESCRIPTION}
            component={EditorFormik}
            className={classes.field}
            xs={12}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            fullWidth
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.START_DATE}
            className={classes.field}
          >
            {({ form, ...formik }) => (
              <DatePickerFormik
                autoOk
                label={ACTIVITY_LOG_FORM_FEILDS_LABELS.START_DATE}
                form={form}
                {...formik}
                format={Format.date_dayfirst}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <Field
            fullWidth
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.END_DATE}
            className={classes.field}
          >
            {({ form, ...formik }) => (
              <DatePickerFormik
                autoOk
                label={ACTIVITY_LOG_FORM_FEILDS_LABELS.END_DATE}
                form={form}
                {...formik}
                format={Format.date_dayfirst}
              />
            )}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <SelectTextFieldFormik
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.STATUS}
            margin="none"
            items={ACTIVITY_LOG_STATUSES}
            name={ACTIVITY_LOG_FORM_FEILDS.STATUS}
            getItemValue={(status) => status.id}
            getItemName={(status) => status.name}
            displayEmpty={false}
            otherOption={'Please select Activity status'}
          />
        </Grid>
        <Grid item xs={6}>
          <SelectTextFieldFormik
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.RESPONSIBLE}
            margin="none"
            items={responsibleUsers}
            name={ACTIVITY_LOG_FORM_FEILDS.RESPONSIBLE}
            getItemValue={(user) => user.directoryId}
            getItemName={(user) => user.fullName}
            displayEmpty={false}
            otherOption={'Please select the responsible user'}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.COMMENT}
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.COMMENT}
            component={EditorFormik}
            className={classes.field}
            xs={12}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            label={ACTIVITY_LOG_FORM_FEILDS_LABELS.MITIGATION_SOLUTIONS}
            margin="none"
            name={ACTIVITY_LOG_FORM_FEILDS.MITIGATION_SOLUTIONS}
            component={EditorFormik}
            className={classes.field}
            xs={12}
          />
        </Grid>
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  fieldWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textfieldLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      background: theme.palette.background.default,
    },
  },
  field: {
    padding: theme.spacing(1),
  },
});

export default withStyles(styles)(ActivityLogFormFields);
